import _defaultsDeep from 'lodash/defaultsDeep';
import Color from 'color';
import colours from '@/styles/base/_colours.scss';
import logoPrimary from '@/assets/images/logo-primary.png';
import logoSecondary from '@/assets/images/logo-secondary.png';

export interface ThemeProperties {
  assets: {
    'logo-primary': string;
    'logo-secondary': string;
  };
  colours: {
    'primary-colour': string;
    'secondary-colour': string;
    'accent-colour': string;
    'brand-colour': string;
    'text-brand-colour': string;
  };
}

export type PublicThemeProperties = Partial<ThemeProperties>;

const defaultThemeProperties: ThemeProperties = {
  assets: {
    'logo-primary': logoPrimary,
    'logo-secondary': logoSecondary
  },
  colours: {
    'primary-colour': colours.primary,
    'secondary-colour': colours.secondary,
    'accent-colour': colours.accent,
    'brand-colour': colours.brand,
    'text-brand-colour': colours.textBrand
  }
};

export class AppTheme {
  themeProperties: ThemeProperties;

  constructor(themeProperties: PublicThemeProperties) {
    this.themeProperties = _defaultsDeep(themeProperties, defaultThemeProperties);
  }

  get logoPrimaryPath(): string {
    return this.themeProperties.assets['logo-primary'];
  }

  get logoSecondaryPath(): string {
    return this.themeProperties.assets['logo-secondary'];
  }

  get cssProps(): Record<string, string> {
    const colours = this.themeProperties.colours;

    return {
      '--logo-primary-path': `url(${this.logoPrimaryPath})`,
      '--logo-secondary-path': `url(${this.logoSecondaryPath})`,

      '--base-primary-colour': colours['primary-colour']!,
      '--base-accent-colour': colours['accent-colour']!,
      '--base-brand-colour': colours['brand-colour']!,
      '--text-brand-colour': colours['text-brand-colour']!,

      '--highlight-primary-colour': Color(colours['primary-colour']).alpha(0.2).string()
    };
  }
}
